import { message, Tooltip, Upload } from "antd";
import {
  IconDeleteItem,
  IconDowload,
  IconExcel,
  IconUploadExcel,
} from "../../../assets/icon";
import BaseButton from "../Button/BaseButton";

export const InputExcelUpload = ({
  className,
  fileList,
  setFileList,
  setError,
  setOpenModalErrorUpload,
}) => {
  const beforeUpload = (file) => {
    const isExcel =
      file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type === "application/vnd.ms-excel";
    if (!isExcel) {
      message.error("Chỉ hỗ trợ định dạng Excel (.xls, .xlsx)");
    }
    return isExcel ? false : Upload.LIST_IGNORE;
  };
  const handleUploadFile = () => {
    setOpenModalErrorUpload(true);
  };
  const handleDowloadFile = () => {
    if (fileList.length > 0) {
      const file = fileList[0];
      const url = URL.createObjectURL(file.originFileObj);
      const link = document.createElement("a");
      link.href = url;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <Upload
        className={className}
        accept=".xls,.xlsx"
        beforeUpload={beforeUpload}
        showUploadList={false}
        fileList={fileList}
        onChange={(info) => {
          const latestFile = info.fileList.slice(-1);
          setFileList(latestFile);
        }}
        maxCount={1}
      >
        <div className="excel-upload-wrapper">
          <div className="file-tag-container">
            {fileList.length === 0 ? (
              <div className="file-placeholder">Chọn 1 tệp Excel</div>
            ) : (
              <div className="file-tag">
                {/* <IconExcel /> */}
                <span className="file-name">{fileList[0].name}</span>
                {/* <span
                  className="file-remove"
                  onClick={(e) => {
                    e.stopPropagation();
                    setFileList([]);
                  }}
                >
                  <IconDeleteItem width={10} height={10} />
                </span> */}
              </div>
            )}
          </div>
          <IconUploadExcel className="upload-icon" />
        </div>
      </Upload>
      {fileList.length > 0 ? (
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          {/* tôi muốn icon ở dưới nếu click vào thì sẽ tải file excel là fileList này về máy thì làm như nào nhỉ */}
          <Tooltip title={"Tải file Excel"}>
            <IconDowload
              style={{ cursor: "pointer" }}
              onClick={() => handleDowloadFile()}
            />
          </Tooltip>
          {/* <div className="button-upload">Tải file lên</div> */}
          <BaseButton
            isEnter={true}
            width={90}
            content={"Tải file lên"}
            typeBtn="btnOrangeupload"
            handleClick={handleUploadFile}
          />
        </div>
      ) : null}
    </div>
  );
};
